import React, { useState, useEffect, useRef } from 'react';
import { Outlet,useLocation } from "react-router-dom";
import { lang, page_url, getTextSize, img_url, openLink, gotoURL, gotoLink, check_brightness, chk_img } from './lang';
import { BsLine } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { RiMenuFill, RiCloseFill, RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { FaPhoneAlt, FaFacebookF, FaEnvelope, FaTwitter, FaYoutube, FaTiktok, FaAlignRight, FaChevronDown } from 'react-icons/fa';
import api from './api';
import layout from '../assets/css/module/layout.module.css';
import ThemeContext from '../context/ThemeContext';
import Menu from './Template/NavMenu';
import enlogo from '../assets/b_en.jpg';
import thlogo from '../assets/b_thai.jpg';

export default function Layout() {
    const [search_type, setSearchType] = useState('food_name');
    const [keyword, setKeyword] = useState('');
    const [menus, setMenus] = useState([]);
    const [show_lang, setShowLang] = useState(false);
    const [show_lang2, setShowLang2] = useState(false);
    const [language, setLang] = useState("th");
    const [page, setPage] = useState("About Us");
    const [init, setInit] = useState({src:undefined});
    const [footer_th, setFooterTh] = useState("");
    const [footer_en, setFooterEn] = useState("");
    const [bg_color, setBGColor] = useState("#fff");
    const [bg_header_th, setBGHeaderTh] = useState("");
    const [bg_header_en, setBGHeaderEn] = useState("");
    const [bg_footer_th, setBGFooterTh] = useState("");
    const [bg_footer_en, setBGFooterEn] = useState("");
    const [article, setArticle] = useState([]);
    const [config, setConfig] = useState({});
    const body_ref = useRef(null);
    const lang_ref = useRef(null);
    const lang_ref2 = useRef(null);
    const location = useLocation();

    const [visitorCount, setVisitorCount] = useState([]);

    useEffect(()=>{
        if(lang==="en"){
            document.title = init.name_en;
        }else{
            document.title = init.name_th;
        }
    },[lang]);

    const fetchMenus = async () =>{
        try {
            const init_response = await api.get('/setting');
            setInit(init_response.data.results);
            let result = init_response.data.results;
            setFooterTh(result.footer_th);
            setFooterEn(result.footer_en);
            const home_config = JSON.parse(result.config);
            setBGColor(home_config.bg_color);
            setBGHeaderTh(home_config.bg_header_th);
            setBGHeaderEn(home_config.bg_header_en);
            setBGFooterTh(home_config.bg_footer_th);
            setBGFooterEn(home_config.bg_footer_en);
            document.title = result.name_th;
            document.body.style.backgroundColor = home_config.bg_color;
            // document.body.style.backgroundImage = "url('/images/th/ntic-main-background.jpg')";
            // console.log(result);

            const home_response = await api.get('/article/1');
            setArticle(home_response.data.results);
            // console.log(home_response.data.results);
            const config = JSON.parse(home_response.data.results.detail);
            setConfig(config);
            const response = await api.get('/menu?type=%main-menu%&order=parent_menu_id,order asc');
              
            let menu = [];
            let menu_index = [];
            response.data.results.forEach(item => {
                if(!menu_index.includes(item.id)){
                  menu_index.push(item.id);
                }
                let menu_active = false;
                if(location.pathname===item.link){
                  menu_active = true;
                  if(menu[menu_index.indexOf(item.parent_menu_id)]){
                    menu[menu_index.indexOf(item.parent_menu_id)].active = true;
                  }
                }
                if(item.parent_menu_id==='0'){
                    let path = location.pathname.split("/");
                    let show = 0;
                    if (location.pathname===item.link||item.link === '/'+path[1]) {
                        show = 1;
                    }
                    // console.log(path);
                    menu[menu_index.indexOf(item.id)] = {
                        child: [],
                        menu_id: item.id,
                        menu_th: item.menu_th,
                        menu_en: item.menu_en,
                        link: item.link,
                        parent_menu_id: item.parent_menu_id,
                        menu_type: item.menu_type,
                        order: item.order,
                        target: item.target,
                        active: menu_active,
                        show: show
                    }
                }else{
                    let set_menu = false;
                    menu.forEach(element => {
                        if(element.menu_id===item.parent_menu_id){
                            let tmp = {
                                        child: [],
                                        menu_id: item.id,
                                        menu_th: item.menu_th,
                                        menu_en: item.menu_en,
                                        link: item.link,
                                        parent_menu_id: item.parent_menu_id,
                                        menu_type: item.menu_type,
                                        order: item.order,
                                        target: item.target,
                                        active: menu_active,
                                        show: 0,
                                    };
                            // console.log(item.id);
                            menu[menu_index.indexOf(item.parent_menu_id)].child.push(tmp);
                            set_menu = true;
                        }
                    });
                    if(set_menu===false){
                        menu.forEach((element,index) => {
                            element.child.forEach((celement,cindex) => {
                                if(item.parent_menu_id===celement.menu_id){
                                    let tmp = {
                                                child: [],
                                                menu_id: item.id,
                                                menu_th: item.menu_th,
                                                menu_en: item.menu_en,
                                                menu_cn: item.menu_cn,
                                                link: item.link,
                                                parent_menu_id: item.parent_menu_id,
                                                menu_type: item.menu_type,
                                                order: item.order,
                                                target: item.target,
                                                active: menu_active,
                                                show: menu_active,
                                            };
                                    // console.log(item.id);
                                    menu[index].child[cindex].child.push(tmp);
                                    set_menu = true;
                                }
                            });
                        });
                    }   
                    if(set_menu===false){
                        console.log("Error Can't set menu",item);
                    }
                }
            });
            // console.log(menu);
            setMenus(menu);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }

    const fetchVisitor = async () => {
      try {
        let visitor = [];
      
        // const response = await api.get('/visitors');
        // let result = response.data;
        // visitor.push({
        //   total:result.today,
        //   title_th:"วันนี้",
        //   title_en:"Today"
        // }); 
        visitor.push({
        //   total:result.yesterday,
          total:1,
          title_th:"วันนี้",
          title_en:"Today"
        }); 
        visitor.push({
        //   total:result.month,
          total:10,
          title_th:"เดือนนี้",
          title_en:"This Month"
        }); 
        // visitor.push({
        // //   total:result.year,
        //   total:10,
        //   title_th:"ปีนี้",
        //   title_en:"This Year"
        // });
        visitor.push({
          //   total:result.all,
          total:10,
          title_th:"สถิติทั้งหมด",
          title_en:"All"
        }); 
        setVisitorCount(visitor);
        localStorage.setItem("visitor",JSON.stringify(visitor));
        localStorage.setItem("last_visited",new Date().toLocaleDateString());
        
      } catch (err) {
          if(err.response){
              //Not in 202 response range
              console.log(err.response.data);
              console.log(err.response.headers);
              console.log(err.response.status);
          } else {
              console.log(`Error: ${err.message}`);
          }
      }
    }

    useEffect(()=>{
          fetchMenus();
          setLang(prev => localStorage.getItem("lang"));

          let visitor=localStorage.getItem("visitor");
          // console.log(visitor);
          if(!visitor){
              fetchVisitor();
          }else{
            var todayDate = new Date().toLocaleDateString();
            let lastVisit=localStorage.getItem("last_visited");
            if(lastVisit!==todayDate){
              fetchVisitor();
            }else{
              
              setVisitorCount(JSON.parse(visitor));
            }
          }
    },[]);


    const handleSearch = (e) => {
        e.preventDefault();
        // console.log(search_type);
        window.location = page_url+"search/"+search_type+"?keyword="+keyword;
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    const setLanguage = (lang) => {
        setLang(prev => lang);
        localStorage.setItem("lang", lang);
    }


    const handleClickOutside = (event) => {
        if (lang_ref.current && !lang_ref.current.contains(event.target)) {
            setShowLang(false);
        }
    }

    useEffect(()=>{
        if(show_lang===true){
          document.addEventListener("mousedown", handleClickOutside);
        }else{
          document.removeEventListener("mousedown", handleClickOutside);
        }
    },[show_lang]);

    const toggleLanguage2 = (e) => {
        e.preventDefault();
        setShowLang2(current=>!current);
    }

    const handleClickOutside2 = (event) => {
        if (lang_ref2.current && !lang_ref2.current.contains(event.target)) {
            setShowLang2(false);
        }
    }

    useEffect(()=>{
          if(show_lang===true){
            document.addEventListener("mousedown", handleClickOutside2);
          }else{
            document.removeEventListener("mousedown", handleClickOutside2);
          }
    },[show_lang2]);
      
    const onSearchTypeChanged = (event) => {
        event.preventDefault();
        setSearchType(event.target.value);
    }
    
    return (
    <ThemeContext.Provider
      value={{ language, page, init }}
    >   
    <div className={layout["page-container"]} style={{backgroundImage:'url('+img_url+lang(bg_header_th,bg_header_en)+')'}}>
        <header ref={body_ref} className={layout["header"]}>
            <div className={layout["tools-box"]}>
                <div className={layout["search-box"]}>
                    <b>{lang('ค้นหา',"Search")}</b>
                    <form>
                        <fieldset>
                            <div className="input-group">
                                <input type="radio" name="search_type" id="search_type" value=  {"food_name"} checked={search_type === "food_name"} onChange={e=>onSearchTypeChanged(e)} /><p>{lang('ชื่ออาหาร','Food name')}</p>
                            </div>
                            <div className="input-group">
                                <input type="radio" name="search_type" id="search_type" value={"ingredient"} checked={search_type === "ingredient"} onChange={e=>onSearchTypeChanged(e)} /><p>{lang('ส่วนผสม','Ingredient')}</p>
                            </div>
                            <div className="input-group">
                                <input type="radio" name="search_type" id="search_type" value={"local_vegetable"} checked={search_type === "local_vegetable"} onChange={e=>onSearchTypeChanged(e)} /><p>{lang('ผักพื้นบ้าน','Local Vegetable')}</p>
                            </div>
                        </fieldset>
                        <fieldset className={layout["search-tool"]}>
                            <input type="text" name="keyword" id="keyword" value={keyword} onChange={e=>setKeyword(e.target.value)} />
                            <button type="button" onClick={e=>handleSearch(e)}><FaSearch /></button>
                            {/* <input type="button" value={lang("ค้นหา","Search")} onClick={e=>handleSearch(e)} /> */}
                        </fieldset>
                    </form>
                </div>
                <div className={layout["language-box"]}>
                    <ul>
                        <li>Tha <img src={thlogo} alt={lang("ภาษาไทย","Thai Version")} onClick={e=>setLanguage("th")} />|</li>
                        <li>Eng <img src={enlogo} alt={lang("ภาษาอังกฤษ","English Version")} onClick={e=>setLanguage("en")} /></li>
                    </ul>
                </div>
            </div>
        </header>
        <main className={layout["content-box"]}>
            <nav className={layout["left-menu"]}>
                <h3>{lang("เมนูหลัก", "Menu")}</h3>
                <ul>
                    {menus.map((element,index)=>
                        <React.Fragment key={"menu"+index}>
                            <li className={(element.child.length>0)?layout["no-hover"]:''} key={'main-menu-'+index}>
                                <a href={element.link}>{lang(element.menu_th,element.menu_en)}</a>
                            </li>
                        {(element.child.length>0)?
                            <>
                            {element.child.map((celement,cindex)=>
                                <li className={layout['submenu']} key={'sub-menu-'+index+'-'+cindex}>
                                <a href={celement.link}>{lang(celement.menu_th,celement.menu_en)}</a>
                                </li>
                            )}
                            </>
                        :''}
                        </React.Fragment>
                    )}
                </ul>
            </nav>
            <article className={layout["article-box"]}>
            <Outlet />
            </article>
        </main>
        {(init)?
        <footer className={layout.footer} style={{backgroundImage:'url('+img_url+bg_footer_th+')'}}>
            <div className={layout["footer-header"]}>
            </div>
            <div className={layout["footer-detail"]}dangerouslySetInnerHTML={{ __html:lang(footer_th,footer_en)}}>
            </div>                 
        </footer>
        :''}
    </div>
    </ThemeContext.Provider>
  )
}
